/**
 * Sign-in routing helpers for the email-first auto-branch flow.
 *
 * Internal MEDirect staff authenticate via Azure AD (Microsoft); external
 * users (medical experts / referrers) use the passwordless email-code flow.
 * We decide which path by email domain.
 */
import { getEnv } from "./env";

const DEFAULT_INTERNAL_DOMAINS = "medirect.com.au";

/** Comma-separated internal domains from env, defaulting to medirect.com.au. */
const getInternalDomains = (): string[] =>
  (getEnv("VITE_INTERNAL_EMAIL_DOMAINS") || DEFAULT_INTERNAL_DOMAINS)
    .split(",")
    .map((d) => d.trim().toLowerCase())
    .filter(Boolean);

/**
 * Whether an email belongs to an internal (Azure AD) domain and should go
 * through the Microsoft sign-in path rather than the email-code path.
 */
export const isInternalEmail = (email: string): boolean => {
  const at = email.lastIndexOf("@");
  if (at < 0) return false;
  const domain = email
    .slice(at + 1)
    .trim()
    .toLowerCase();
  return getInternalDomains().includes(domain);
};
